import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  createTheme,
  ThemeProvider as MuiThemeProvider,
} from '@material-ui/core/styles';
import { deepmerge } from '@material-ui/utils';
import DEFAULT_THEME from '../constants/index';

const ThemeProvider = ({ theme, options, children }) => {
  const mergedTheme = useMemo(
    () => createTheme(deepmerge(theme, options)),
    [theme, options]
  );

  return <MuiThemeProvider theme={mergedTheme}>{children}</MuiThemeProvider>;
};

ThemeProvider.defaultProps = {
  theme: DEFAULT_THEME,
  options: {},
};

ThemeProvider.propTypes = {
  theme: PropTypes.object,
  options: PropTypes.object,
  children: PropTypes.any.isRequired,
};

export default ThemeProvider;
